import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';
import { MetricDataList } from './types/MetricDataList';

export class MetricDataPointsChannel extends MicroviewCommunicationChannel<{ metricIds: string[] }, Promise<MetricDataList>> {
  public name: string = 'MetricDataPointsChannel';
  public namespace: string = 'SearchMicroview.MetricDataPoints';
}
